import { FaRegCircleDot } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { GoDotFill } from "react-icons/go";
import React from "react";
import Main from "./components/Main";
import Home from "./components/Home";
import Page from "./components/Page";
import DeliveringCare from "./components/DeliveringCare";
import ProfessionalPractice from "./components/ProfessionalPractice";
import Advocacy from "./components/Advocacy";
import MemberInsurance from "./components/MemberInsurance";
import News from "./components/News";
import About from "./components/About";
import AwardCertificates from "./components/AwardCertificates";
import Partners from "./components/Partners";
import ResourceBank from "./components/ResourceBank";
import Careers from "./components/Careers";
import HealthInsurance from "./components/HealthInsurance";
import ResearchInnovation from "./components/ResearchInnovation";
import TrainingInstitutions from "./components/TrainingInstitutions";
import General from "./components/General"
import Psychiatry from "./components/Psychiatry"
import Advanced from "./components/Advanced"
import MedicalPractitioner from "./components/MedicalPractitioner";
import MedicalLicentiates from "./components/MedicalLicentiates";
import ClinicalAnesthetics from "./components/ClinicalAnesthetics";
import MentalPsychiatry from "./components/MentalPsychiatry";
import ClinicalOphthalmic from "./components/ClinicalOphthalmic";
import SpecializedClinicians from "./components/SpecializedClinicians";
import HIV from "./components/HIV";
import FullMember from "./components/FullMember";
import AssociateMember from "./components/AssociateMember";
import StudentMember from "./components/StudentMember";

export const people = [
  {
    name: "Jones Neba",
    gendar: "male",
    position: "Hon President",
    tenure: "2022 - 2026",
    about: [
      "Jones Neba is a Fully licensed clinical officer General with a Bachelor of Science in Clinical Medicine, a Licensed Medical Licentiate Practitioner (MLP). He has served as a Lecturer in various institutions,  a consultant in programme development, a professional examiner with various examination bodies and has served as an external examiner in various universities and colleges. Mr. Neba has experience of over 10 years in leadership, corporate governance and health service delivery. He is currently working as HOD for Clinical Medicine at a University and also providing consultancy works in Higher education. He has taught over 3000 clinical officers in Zambia",
      "He has contributed and guided drafting of various policy documents, from COAZ to health professions. Further, Neba is a trainer of trainers in HIV and AIDS management",
    ],
    qualifications: [
      "Master of Science in Clinical Pathology",
      "Bachelor Science of Human biology",
      "Bachelor of science in Clinical Medicine",
      "Diploma in clincal medicine",
      "Certificate in HIV AIDS",
      "Certificate in Corporate governance",
      "Certificate from Institute of Directors in governance",
    ],
    contributions: [
      "Mr. Neba has been instrumental in the growth of COAZ where he has provided overall leadership for the organization, seeing it grow from Less than 30 members to over 8000 in the space of 2 years. He has been instrumental in guiding organization's overall policy direcion and is charged as the organization's Chairman",
      "Neba previously served as vice president for the association",
      "Neba is a board Member of the Health Professions council of Zambia",
      "He is a member of HPCZ training committee of the board",
    ],
    email: "jones.neba1986@gmail.com",
    image: "/images/neba.jpg",
  },
  {
    name: "Musonda Kamfwa",
    gendar: "male",
    position: "Hon Secretary General",
    tenure: "2022 - 2026",
    about: [
      "Mr. Kamfwa is a Fully Licensed Clinical Officer General with a Diploma In Clinical Medicine.  Hes additionally " +
        "a licensed public health Specialist and scientist. With over 5 years Experience in Health service management, program" +
        " management and consultancy. As a freelance consultant, he's provided consultancy work with various organizations " +
        "from HIV/AIDs programming to planning and implementation of Health systems strengthening programs, policy development" +
        " and analysis to training institution learning programme development",
      "Professionally, Mr. Kamfwa has served as Manager for HIV/TB/cervical cancer, prevention programs in 3 " +
        "provinces in Zambia in various districts, where he led Technical assistance teams and supervised District " +
        "technical teams under care and treatment PEPFAR funded projects. Additionally, he has serviced as a " +
        "Consultant for reputable institutions such as LIAS University,  World Bank, the Ministry of Health, and " +
        "others. outside the association, Mr kamfwa serves on the committee of the HPCZ board - Registrations committee",
      "Mr. Kamfwa has participated in drafting of the following ;",
      "- National Health policy",
      "- National Health strategic plan for the ministry of health",
      "- health professions bill",
      "- Higher education amendment bill",
      "- participated in committee review of legislation at parliament",
      "- drafting of National Health research authority training guidelines",
      "- BSc and Diploma clinical Medicine training standards with Higher education Authority",
      "- and more",
    ],
    qualifications: [
      "He is a Public Health specialist and clinical officer by profession",
      "Master of Public Health",
      "Master of Public Administration",
      "Bachelor of medical science",
      "Bachelor of science in public health",
      "Diploma in clinical medicine",
      "Postgraduate diploma in project management",
      "Certificate in Project management",
      "Certificate in pediatrics and adult HIV management",
      "Certificate in monitoring and evaluation in Global Health",
      "He is a Ph.D candidate in Public Health (health policy)",
    ],
    contributions: [
      "Mr. Kamfwa has been at the centre of enrolling members into the organization,  moving the organization membership from less than 30 to over 8000",
      "He has been involved in the drafting of the organizations policies and all administrative processes, setting a foundation for the association",
      "Led Drafting of RoadMap for Clinical Officer workforce in the ministry of health",
      "Led drafting of COAZ strategic plan",
      "Led the drafting of COA Training and CPD policy",
      "Founder of the COAZ page",
    ],
    publications:
      "https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=https://socialinnovationsjournal.com/index.php/sij/article/download/991/740/3781%23:~:text%3DA%2520clinical%2520officer%2520in%2520Zambia%2520performs%2520general%2520and%2520specialized%2520medical,managing%2520health%2520departments%252C%2520institutions%252C%2520projects&ved=2ahUKEwiZz5vow8eHAxXWwAIHHU5gDOQQFnoECBMQBQ&usg=AOvVaw1hkgd10Mt0Dv2jtF9TTYmm",
    email: "joseph.kamfwa@yahoo.com",
    image: "/images/kamfwa.jpg",
  },
  {
    name: "Jonathan Tapalu",
    gendar: "male",
    position: "Hon National Publicity Secretary",
    tenure: "2022 - 2026",
    about: [
      "Jonathan Tapalu is a Fully licensed clinical officer General with a Bachelor of Science in Clinical Medicine, a Licensed Medical Licentiate Practitioner (MLP). He has been practicing for more than 10years, and has dip. Healthy Public emergency operating systems.  He is currently working attached with the Ministry of Health HQ and overseeing medical emergencies as Chief Emergency Officer",
      "He has contributed in drafting of various policy documents, at the Ministry of Health and COAZ. Further, Mr. Tapalu is a trainer of trainers in BLS/ALS management",
    ],
    qualifications: [
      "Bachelor of science in Clinical Medicine",
      "Diploma in clincal medicine",
      "Certificate in public Health Emergency operations systems",
      "Certificate in HIV AIDS",
      "Certificate in leadership and Management",
    ],
    contributions: [
      "Mr. Tapalu has been instrumental as he was the one that came up with a modified logo of COAZ",
      "Mr. Tapalu previously served as a committee member",
    ],
    email: "jtapalu@gmail.com",
    image: "/images/tapalu.jpg",
  },
  {
    name: "Emmanuel Kashimu",
    gendar: "male",
    position: "Hon Deputy National Publicity",
    tenure: "2022 - 2026",
    about: [
      "Mr. Kashimu Emmanuel is a clinical officer - General, fully Licensed by the health professions Council of Zambia. He is currently working from Sinda District in the Eastern province. He is substantively employed as a Senior Clinical Officer - HIV/TB/STI/Leprosy for Sinda under the ministry of health",
      "Mr. Kashimu Emmanuel has been a member of COAZ for over 5 yrs and is additionally serving as Acting Eastern provincial Chairperson for COAZ Eastern",
      "Mr. Kashimu Emmanuel has served as Health Centre In-charge for 2 different Health Centres and Mini Hospital both Administratively and on Promotional Basis",
    ],
    qualifications: [
      "Diploma in Clinical Medical Sciences",
      "Certificate in Project Management in Global Health",
      "Certificate Clinical Management of HIV in Global Health",
      "Certificate in Leadership and Management in Global Health",
      "Certificate in Monitoring and Evaluation in Global Health",
    ],
    contributions: [
      "He has contributed to the Association by spearheading social media publications under the guidance of the office the national publicity secretary, with support from the secretary General",
    ],
    image: "/images/kashimu.jpg",
  },
  {
    name: "Martha Mwiya",
    gendar: "female",
    position: "Hon National Treasurer",
    tenure: "2022 - 2026",
    about: [
      "Martha is a Licensed Clinical officer General working at Ndola Teaching hospital, the largest teaching hospital on the copperbelt province",
    ],
    qualifications: [
      "Diploma in clinical Medicine",
      "Certificate of competence in financial management",
    ],
    contributions: [
      "Has been a member of the association for over 7 years.",
      "One of the earliest members of the association",
      "She's the National Treasurer for the association",
    ],
    image: "/images/mwiya.jpg",
  },
  {
    name: "Peter Mwanaumbi",
    gendar: "male",
    position: "Hon Deputy Secretary General",
    tenure: "2022 - 2026",
    about: [
      "Mr. Mwanaumbi is a Licensed Clinical officer General working at Ndola Teaching hospital, the largest teaching hospital on the copperbelt province. He is the Deputy Secretary General for the association",
    ],
    qualifications: ["Diploma in clinical Medicine"],
    contributions: [
      "Has been a member of the association for over 7 years.",
      "One of the earliest members of the association",
    ],
  },
];

export const findPerson = (position) => {
  return people.find((person) => {
    return person.position.toLowerCase().includes(position.toLowerCase());
  });
};

export const association = {
  name: "The Association",
  menus: [
    {
      image: "/images/img_26.jpg",
      name: "Delivering Care",
      link: "delivering_care",
      Element: DeliveringCare
    },
    {
      image: "/images/img_17.jpg",
      name: "Professional Practice",
      link: "professional_practice",
      Element: ProfessionalPractice
    },
    {
      image: "/images/img_10.jpg",
      name: "Training Institutions and Students",
      link: "training_institutions_and_students",
        Element:TrainingInstitutions
    },
    {
      image: "/images/img_8.jpg",
      name: "Advocacy on Health Insurance in Zambia",
      link: "advocacy_in_health_care",
      Element: Advocacy,
    },
    {
      image: "/images/img_5.jpg",
      name: "Member Health Insurance",
      link: "Member_Health_Insurance",
      Element: MemberInsurance
    },
  ],
};

export const services = {
  name: "Services",
  link: "/services",
  menus: [
    {
      image: "/images/img_49.jpg",
      name: "Learning And CPD",
      link: "https://cpd.coaz.org/",   // external: opens the CPD site in a new tab
    },
    {
      image: "/images/image.jpg",
      name: "Health Insurance",
      link: "health_insurance",
      Element:HealthInsurance
    },
    {
      image: "/images/bg_8.jpg",
      name: "Awards and Certificates",
      link: "awards_and_certificates",
      Element: AwardCertificates
    },
    {
      image: "/images/img_28.jpg",
      name: "Resource Banking",
      link: "resource_banking",
      Element: ResourceBank
    },
    {
      image: "/images/img_6.jpg",
      name: "Research and Innovation Hub",
      link: "research_and_innovation",
      Element:ResearchInnovation
    },
    {
      image: "/images/img_32.jpg",
      name: "Partners",
      link: "partners",
      Element: Partners
    },
    {
      image: "/images/img_47.jpg",
      name: "Careers",
      link: "careers",
      Element: Careers
    },
  ],
};

export const categories = [
  {
    name: "Clinical Officers",
    professionalCatories: [
      {
        name: "General",
        link: "general",
        Element:General
      },
      {
        name: "Psychiatry",
        link: "psychiatry",
        Element:Psychiatry
      },
      {
        name: "HIV/TB",
        link: "hivtb",
        qualification: "",
        zambiaQualificationAuthority: "",
        minimumCreditRequirement: "",
        areaOfPractice: "",
        limitationsInDrugPrescription: "",
        limitationInStatutoryAndLegalDocumentSignatory: "",
        administration: "",
        scope: "",
        Element:HIV
      },
      {
        name: "Advanced",
        link: "advanced",
        Element:Advanced
      },
    ],
  },
  {
    name: "Licentiate",
    professionalCatories: [
      {
        name: "Medical Licentiate Officer/ Practitioner",
        link: "medical_licentiate_officer_practitioner",
        Element:MedicalPractitioner

      },
      {
        name: "Medical Licentiates",
        link: "medical_licentiates",
        Element:MedicalLicentiates
      },
    ],
  },
  {
    name: "Others",
    professionalCatories: [
      {
        name: "Clinical Anaesthetic Officers",
        link: "clinical_anaesthetic_offices",
        Element:ClinicalAnesthetics

      },
      {
        name: "Mental Health Officers",
        link: "medical_psychiatry_officers",
        Element:MentalPsychiatry

      },
      {
        name: "Clinical Ophthalmic Officers",
        link: "clinical_ophthalmic_offices",
        Element:ClinicalOphthalmic
      },
      {
        name: "Specialized Clinicians",
        link: "specialized_clinicians",
        Element:SpecializedClinicians
      },
    ],
  },
];

const getProfessionalCategories = () => {
  let pfCats = [];
  for (let category of categories) {
    for (let pfCat of category.professionalCatories) {
      pfCats.push(pfCat);
    }
  }
  return pfCats;
};

export const professionalCategories = {
  name: "Categories",
  link: "/categories",
  menus: (() => {
    return getProfessionalCategories();
  })(),
};

export const organisation = {
  name: "Organisation",
  link: "/organisation",
  menus: [
    {
      name: "Governance",
      link: "/organisation/governance",
      menus: [
        {
          name: "National Executive Committee",
          link: "/organisation/governance/national_executive_committee",
          about: [
            "Executive authority of the Association derives from its members and exercises in a manner that promotes:",
          ],
          composition: [
            {
              name: "",
              position: "Hon President",
              image: "",
            },
            {
              name: "",
              position: "Hon Vice President",
              image: "",
            },
            {
              name: "",
              position: "Hon Secretary General",
              image: "",
            },
            {
              name: "",
              position: "Hon Deputy Secretary general",
              image: "",
            },
            {
              name: "",
              position: "Hon National Treasurer",
              image: "",
            },
            {
              name: "",
              position: "Hon National Publicity",
              image: "",
            },
            {
              name: "",
              position: "Nominated Members",
              image: "",
            },
          ],
        },
        {
          name: "National Investment Board",
          link: "/organisation/governance/national_investment_board",
          about: [
            "Presides over investments of the association and other related matters",
          ],
          composition: [
            {
              name: "",
              position: "The Chairperson",
              image: "",
            },
            {
              name: "",
              position: "Vice Chairperson",
              image: "",
            },
            {
              name: "",
              position: "Board Member 1",
              image: "",
            },
            {
              name: "",
              position: "Board Member 2",
              image: "",
            },
            {
              name: "",
              position: "Board Member 3",
              image: "",
            },
          ],
        },
        {
          name: "Committees of the Executive",
          link: "/organisation/governance/committees_of_the_executive",
          menus: [
            {
              name: "The Disciplinary, Ethics, and Professionalism",
              link: "/organisation/governance/committees_of_the_executive/disciplinary_ethics_and_professionalism",
              about: [
                "Its mandate encompasses the development, enforcement, and continuous enhancement of ethical guidelines and codes of conduct within the professional community. Through rigorous investigation, fair adjudication, and education initiatives, strives to maintain an environment where ethical behavior remains of highest standard",
              ],
              composition: [
                {
                  name: "",
                  position: "The Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Vice Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 1",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 2",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 3",
                  image: "",
                },
              ],
            },
            {
              name: "Training and Education",
              link: "/organisation/governance/committees_of_the_executive/training_and_education",
              about: [
                "Has a strategic focus in cultivating a dynamic and innovative educational system that equips members with the knowledge, skills, and competencies essential for leadership and excellence in clinical practice, research, and advocacy",
                "Through cutting-edge curriculum development, Continuing professional development (CPD/CME), transformative pedagogical approaches, and strategic partnerships, the committee provides a direction, implementation and advocacy for a lifelong learning and continuous professional growth for the clinical professions",
              ],
              composition: [
                {
                  name: "",
                  position: "The Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Vice Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 1",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 2",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 3",
                  image: "",
                },
              ],
            },
            {
              name: "Finance and Administration",
              link: "/organisation/governance/committees_of_the_executive/finance_and_administration",
              about: [
                "the steward for the profession's financial sustainability, operational effectiveness, and governance excellence. With a strategic focus on fiscal management, transparency, and accountability",
                "The committee is mandated in the development of financial management practices, the optimization of administrative processes, and the cultivation of a governance framework that improves organizational resilience",
              ],
              composition: [
                {
                  name: "",
                  position: "The Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Vice Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 1",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 2",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 3",
                  image: "",
                },
              ],
            },
            {
              name: "Health Services",
              link: "/organisation/governance/committees_of_the_executive/health_service",
              about: [
                "A committee of the executive that is a strategic driver for optimizing healthcare delivery, enhancing quality of care, and promoting equitable access to services",
                "The committee focuses on identifying systemic barriers and inefficiencies, formulating evidence-based strategies for service improvement, and advocating for policies and initiatives that prioritize patient-centered care, health equity, and population health outcomes",
                "Through collaboration, innovation, and advocacy, the committee endeavors to shape a healthcare landscape that ensures high-quality, accessible, and equitable care for all individuals and communities",
              ],
              composition: [
                {
                  name: "",
                  position: "The Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Vice Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 1",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 2",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 3",
                  image: "",
                },
              ],
            },
            {
              name: "Legislation and Judicial",
              link: "/organisation/governance/committees_of_the_executive/legislation_and_judicial",
              about: [
                "The principal advocate and strategist for the profession's policy agenda, legislative priorities, and legal interests. The Committee’s mandate is to anticipate, analyze, and influence policy and legislative developments, champion initiatives that advance the interests and welfare of the profession and to provide expert guidance and representation in legal matters affecting members",
              ],
              composition: [
                {
                  name: "",
                  position: "The Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Vice Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 1",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 2",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 3",
                  image: "",
                },
              ],
            },
            {
              name: "Public Health and Research",
              link: "/organisation/governance/committees_of_the_executive/public_health_and_research",
              about: [
                "A committee of the executive that is charged with advancing scientific discovery, research excellence, and public health impact. At the intersection of inquiry and action, the committee has a mandate that encompasses the promotion of rigorous scientific inquiry, the dissemination of evidence-based knowledge, and the translation of research findings into policies and practices that promote health equity and societal well-being",
                "Committed to scientific integrity, innovation, and collaboration. Strives to leverage the collective expertise and influence of the profession to address pressing health challenges and drive meaningful change at local, national, and global levels",
              ],
              composition: [
                {
                  name: "",
                  position: "The Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Vice Chairperson",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 1",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 2",
                  image: "",
                },
                {
                  name: "",
                  position: "Board Member 3",
                  image: "",
                },
              ],
            },
          ],
        },
        {
          name: "National Program Coordinators",
          link: "/organisation/governance/national_program_coordinator",
        },
        {
          name: "Provincial Executive Committee",
          link: "/organisation/governance/provincial_executive_committee",
        },
        {
          name: "District Executive Committees",
          link: "/organisation/governance/district_executive_committees",
        },
      ],
    },

    {
      name: "Administration",
      link: "/organisation/administration",
      menus: [
        {
          name: "Employees of the Association",
          link: "/organisation/administration/employees",
          employees: [
            {
              name: "",
              position: "Administrative secretary – Legal Services",
              image: "",
            },
            {
              name: "",
              position: "Administrative assistant – finance and administration",
              image: "",
            },
            {
              name: "",
              position: "Administrative assistant – front office services",
              image: "",
            },
            {
              name: "",
              position: "Information Technology officer (ITO)",
              image: "",
            },
            {
              name: "",
              position: "IT assistant – systems management",
              image: "",
            },
            {
              name: "",
              position:
                "Project officer – Hospital and infrastructure services",
              image: "",
            },
            {
              name: "",
              position: "Drivers",
              image: "",
            },
          ],
        },
      ],
    },

    {
      name: "Laws Of The Association",
      link: "/organisation/laws",
      about: [
        <p
          key="intro"
          className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]"
        >
          The Association will be governed in accordance with the following
          instruments, in order of precedence:
        </p>,

        <div key="bullets" className="flex flex-col space-y-4 mt-6 w-full">
          <div className="flex flex-row space-x-4">
            <GoDotFill
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              This Constitution
            </p>
          </div>

          <div className="flex flex-row space-x-4">
            <GoDotFill
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Resolutions of the General Assembly
            </p>
          </div>

          <div className="flex flex-row space-x-4">
            <GoDotFill
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              By-laws and Regulations
            </p>
          </div>

          <div className="flex flex-row space-x-4">
            <GoDotFill
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Membership Code of Conduct
            </p>
          </div>

          <div className="flex flex-row space-x-4">
            <GoDotFill
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Professional Code of Conduct
            </p>
          </div>

          <div className="flex flex-row space-x-4">
            <GoDotFill
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Other Applicable National Laws
            </p>
          </div>
          <p
            style={{ fontSize: "25px", lineHeight: "52px" }}
            className="flex w-[90%] lg:w-[600px] h-auto mt-6 text-left text-[rgb(50,50,50)] font-leBeauneNew"
          >
            Constitution
          </p>
          <p className="text-[rgb(85,85,85)] text-lg font-jostSemi">
            Download the official constitution of the Clinical Officers
            Association of Zambia below.
          </p>

          <div className="flex justify-center mt-4">
            <a
              href="/Files/COAZ_CONSTITUTION_2025.pdf"
              download
              className="px-6 py-3 bg-blue-600 text-white font-jostSemi rounded-lg shadow hover:bg-blue-800 transition"
            >
              Download Constitution (PDF)
            </a>
          </div>
        </div>,
      ],
    },
  ],
};

export const membership = {
  name: "Membership",
  link: "/membership",
  menus: [
    {
      name: "Full Membership",
      link: "full_membership",
      EligibilityCriteria: () => (
        <div className="flex flex-col space-y-8 w-full h-auto">
          <p className="flex w-full h-auto font-semibold font-leBeauneNew text-[22px] lg:text-4xl text-[rgb(59,59,59)]">
            Eligibility Criteria
          </p>

          <p className="text-lg tracking-wider mt-2 font-jostBook text-[rgb(85,85,85)]">
            A person shall qualify for Full Membership of the Association if
            they;{" "}
          </p>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Hold a valid qualification as a Clinical Officer or mid-level
              clinical practitioner recognized by the Health Professions Council
              of Zambia (HPCZ).
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Possess a current license or registration to practice clinical
              medicine in Zambia.
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Demonstrate good professional standing, with no outstanding
              disciplinary sanctions or unresolved ethical complaints.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Have paid the prescribed membership fees and complied with any
              registration or administrative requirements of the
              Association.{" "}
            </p>
          </div>
        </div>
      ),
      Element:FullMember
    },
    {
      name: "Associate Membership",
      link: "associate_membership",
      EligibilityCriteria: () => (
        <div className="flex flex-col space-y-8 w-full h-auto">
          <p className="flex w-full h-auto font-semibold font-leBeauneNew text-[22px] lg:text-4xl text-[rgb(59,59,59)]">
            Eligibility Criteria
          </p>
          <p className="w-full h-auto text-lg text-[rgb(100,100,100)] font-jostBook">
            Eligibility for Associate Membership shall include persons who;
          </p>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Are qualified Clinical Officers or mid-level clinical
              practitioners not currently engaged in active clinical practice.
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Are Clinical Officers practicing outside the jurisdiction of
              Zambia.
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Meet any additional criteria established by the National Executive
              Committee.
            </p>
          </div>
        </div>
      ),
      Element:AssociateMember
    },
    {
      name: "Student Membership",
      link: "student_membership",
      EligibilityCriteria: () => (
        <div className="flex flex-col space-y-8 w-full h-auto">
          <p className="flex w-full h-auto font-semibold font-leBeauneNew text-[22px] lg:text-4xl text-[rgb(59,59,59)]">
            Eligibility Criteria
          </p>
          <p className="w-full h-auto text-lg text-[rgb(100,100,100)] font-jostBook">
            Student Membership shall be open to individuals who;
          </p>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Are formally enrolled in an accredited institution offering
              Clinical Officer training or equivalent mid-level clinical
              education.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Subscribe to and uphold the values and objectives of the
              Association.
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Comply with any registration procedures and payment of applicable
              fees as determined by the Association.{" "}
            </p>
          </div>
        </div>
      ),
      Element:StudentMember
    },
    {
      name: "Life Membership",
      link: "life_membership",
      EligibilityCriteria: () => (
        <div className="flex flex-col space-y-8 w-full h-auto">
          <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
            Life membership may be conferred upon a Full Member who;
          </p>

          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Has rendered distinguished and long-standing service to the
              profession and the Association.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Has been an active, compliant member for not less than fifteen
              (15) consecutive years.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Is nominated by at least five members and approved by the National
              Executive Committee.
            </p>
          </div>
        </div>
      ),
    },
    {
      name: "Honorary Membership",
      link: "honorary_membership",
      EligibilityCriteria: () => (
        <div className="flex flex-col space-y-8 w-full h-auto">
          <p className="flex w-full h-auto font-semibold font-leBeauneNew text-[22px] lg:text-4xl text-[rgb(59,59,59)]">
            Eligibility Criteria
          </p>
          <p className="w-full h-auto text-lg text-[rgb(100,100,100)] font-jostBook">
            Honorary Membership may be conferred on individuals who;
          </p>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Have rendered distinguished service or contribution to the
              Clinical Officer profession or the Association.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Do not otherwise meet the criteria for Full or Associate
              Membership.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Are nominated and approved in accordance with this
              Constitution.{" "}
            </p>
          </div>
        </div>
      ),
    },
    {
      name: "Affiliate Membership ",
      link: "affiliate_membership",
      EligibilityCriteria: () => (
        <div className="flex flex-col space-y-8 w-full h-auto">
          <p className="flex w-full h-auto font-semibold font-leBeauneNew text-[22px] lg:text-4xl text-[rgb(59,59,59)]">
            Eligibility Criteria
          </p>
          <p className="w-full h-auto text-lg text-[rgb(100,100,100)] font-jostBook">
            Affiliate Membership may be granted to;
          </p>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Institutions, organizations, or individuals from related health
              professions who support the objectives of the Association.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Persons meeting any conditions prescribed by the National
              Executive Committee.{" "}
            </p>
          </div>
        </div>
      ),
    },
    {
      name: "Retired Membership",
      link: "retired_membership",
      TerminationProcedure: () => (
        <div className="flex flex-col space-y-8 w-full h-auto">
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Retired Membership shall be granted to Full Members who have
              formally retired from active professional practice and apply
              accordingly.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              The Association shall have the power to verify eligibility and
              require evidence or documentation to support membership
              applications.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Membership shall be granted only upon compliance with the
              eligibility criteria and payment of any prescribed fees, as
              determined by the Association’s regulations.{" "}
            </p>
          </div>
        </div>
      ),
    },
    {
      name: "Termination Of Membership",
      link: "termination",
      TerminationProcedure: () => (
        <div className="flex flex-col space-y-8 w-full h-auto">
          <div className="flex flex-row space-x-4">
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Membership may be terminated by the Association under the
              following circumstances;{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Non-payment of prescribed membership fees or dues within the
              stipulated period, after notice.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Breach of the provisions of this Constitution, the Association’s
              Code of Conduct, or any other rules and regulations of the
              Association.
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Conviction of a criminal offence or professional misconduct that
              undermines the reputation or integrity of the Association.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Conduct detrimental to the interests, objectives, or reputation of
              the Association.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Failure to maintain professional licensure or registration as
              required by law.{" "}
            </p>
          </div>
          <div className="flex flex-row space-x-4">
            <FaRegCircleDot
              size={16}
              className="text-[rgb(85,85,85)] mt-[5px] shrink-0"
            />
            <p className="text-lg tracking-wider font-jostBook text-[rgb(85,85,85)]">
              Any other grounds as prescribed by the Association’s disciplinary
              procedures.{" "}
            </p>
          </div>
        </div>
      ),
    },
  ],
};

/* export const menus = [
    {
        name:'Home',
        link:'/home'
    },
    (() => {return association})(),
    (() => {return services})(),
    (() => {return professionalCategories})(),
    (() => {return organisation})(),
    (() => {return membership})(),
    {
        name:'About',
        link:'/about'
    },
    {
        name:'News and Events',
        link:'/news'
    }
]; */

export const rootMenu = {
  name: "",
  link: "/",
  Element: Main,
  menus: [
    {
      name: "Home",
      link: "",
      Element: Home,
    },
    (() => {
      return association;
    })(),
    (() => {
      return services;
    })(),
    (() => {
      return professionalCategories;
    })(),
    (() => {
      return organisation;
    })(),
    (() => {
      return membership;
    })(),
    {
      name: "About",
      link: "/about",
      Element: About,
    },
    {
      name: "News",
      link: "/news",
      Element: News,
    },
  ],
};

export const partners = [
  {
    image: "/images/hpcz.png",
    description:
      "Collaborates in enforcement of regulations, standards of practice and other functions",
  },
  {
    image: "/images/hea.png",
    description:
      "Collaborates with the higher education Authority in matters of training and other matters related",
  },
  {
    image: "/images/moh.png",
    description:
      "Providing Health services and enforcing standards in health service delivery",
  },
  {
    image: "/images/local_authority.png",
    description:
      "Works to strengthen local involvement in Health services and others",
  },
];

export const news = [
  {
    tag: "Lab coat",
    image: "/images/img3_1.jpg",
    date: "February 11, 2025",
    heading: `Distribution of Lab coat At Matero level one Hospital`,
    content: "",
  },

  {
    tag: "Lab coat",
    image: "/images/img1_1.jpg",
    date: "February 12, 2025",
    heading: "Distribution of Lab coat At Chelston Level one Hospital",
    content:
      "COAZ president with over 45 clinical officers from the sub-District and representative of Troika pharmaceuticals.",
  },

  {
    tag: "Lab coat",
    image: "/images/img2_1.jpg",
    date: "February 15, 2025",
    heading: `Distribution of Lab coat At Kanyama level one Hospital`,
    content: "",
  },

  {
    tag: "Lab coat",
    image: "/images/img4_1.jpg",
    date: "",
    heading: `Distribution of Lab coat At Kabwe General Hospital`,
    content: "",
  },

  {
    tag: "Lab coat",
    image: "/images/img5_2.jpg",
    date: "February 19, 2025",
    heading: `Distribution of Lab coat At Luanshya level one Hospital`,
    content:
      "The Association Led By Deputy Secretary Mr. peter mwanaumbi Visited Luanshya District Today to support membership on matters of Health Services.",
  },

  {
    tag: "Lab coat",
    image: "/images/img6_2.jpg",
    date: "February 15, 2025",
    heading: `Distribution of Lab coat At Chipata First Level Hospital`,
    content:
      "COAZ executive and CHIPATA subdistrict members at CHIPATA Level hospital.",
  },
  {
    tag: "AGM",
    image: "/images/img_g3.jpg",
    date: "15 October, 2024",
    heading: "2024 Annual general meeting",
    content:
      " The Just ended annual general meeting held on 15 October, 2024 In Lusaka, who’s themes: strengthening Clinical care services through training and development and graced by the representative from the Ministry of health, in the company of Coaz president Mr. Jones Neba and Secretary General Mr. Musonda Kamfwa.",
  },
  {
    tag: "AGM",
    image: "/images/img_g8.jpg",
    date: "15 October, 2024",
    heading: '2024 AGM "MOST DEDICATED CLINICIAN AWARD IN LEADERSHIP"',
    content:
      "Congratulations to the association’s secretary General Mr. Musonda Kamfwa who received this award yesterday at the on-going COAZ Annual Conference. .",
  },
  {
    image: "/images/img_36.jpg",
    date: "April 15, 2024",
    heading: "Professional practice",
    content:
      "Patients in Primary Health care facilities deserve care led by Clinical practioners—the most highly educated, trained and skilled health care professionals at such levels. Through research, advocacy and education, the COAZ vigorously defends the Clinical practice against scope of practice expansions that threaten patient safety",
  },
  {
    tag: "in other news",
    image: "/images/img_a1.jpg",
    date: "February 7, 2025",
    heading: `Trooika Pharmaceuticals and COAZ`,
    content:
      "Another successful year has started, and COAZ Executive continues to engage with key partners. We are pleased to have received in assurance from Mr. Ankit, the Managing Director of Trooika Pharmaceuticals, regarding their ongoing support for the association. This includes providing employment opportunities to our members and assisting with our programs whenever needed. As an association, we are both proud and excited about your timely and generous partnership. We look forward to continuing our support for the excellent products listed below. BY COAZ MEDIA.",
  },
  {
    tag: "in other news",
    image: "/images/img_a2.jpg",
    date: "February 7, 2025",
    heading: `Trooika Pharmaceuticals and COAZ`,
    content: " ",
  },
  {
    tag: "in other news",
    image: "/images/img_b1.jpg",
    date: "February 4, 2025",
    heading: ``,
    content:
      "The COAZ Executive, led by the President, visited the Higher Education Authority (HEA) Director-General professor Kazhila Chinsembu. The purpose of the meeting was to discuss potential collaboration in the accreditation and registration process of higher learning institutions offering Clinical Medicine. This engagement comes in response to the increasing number of training institutions in this field, despite a noticeable decline in the quality of education, particularly in terms of skills, knowledge, and, most concerning, the attitude of graduates.We strongly urge training institutions to adhere to the recommended entry requirements as they enrol students in their programmes. Furthermore, we call on the HEA to take necessary action, including the possible closure of institutions that fail to comply with the established standards. COAZ remains committed to engaging with the HEA to ensure quality assurance in institutions offering Clinical Medicine.Jones Neba President COAZ.",
  },
  {
    tag: "in other news",
    image: "/images/flag.jpg",
    date: "February 4, 2025",
    heading: `COAZ is not surprised`,
    content:
      "The Clinical Officers Association of Zambia - COAZ) is not surprised by the indirect admission by the Hon. Minister of Health, Dr. E Muchima, regarding the possibility of corruption in the recent recruitment of health workers.The association sympathizes with the minister, the public, and unemployed health workers who may have been disadvantaged by such actions. We have consistently stated that the current composition of the Human Resources Committee involved in recruitment is inadequate and leaves much to be desired. It creates loopholes that could potentially champion corruption, including cronyism.Therefore, we call on the government, through the Ministry of Health and the Civil Service Commission, to disband all Human Resources Management (HRM) committees at the district and provincial levels and reconstitute them.“How can such committees be devoid of the involvement of critical civil society and professional organizations, such as ourselves and other health associations, who are the custodians of healthcare?”The decentralization policy has clearly outlined the roles of associations and civil society organizations, yet it is shocking to see us excluded at the such levels.As long as these committees remain as they are, we can expect cronyism, nepotism, bribery, and other forms of corruption to undermine our nation’s fight against such vices.We are better positioned to advise on recruitment matters, as we are represented in every district and have a deeper understanding of health-related issues. It is only in Zambia where health workers have little to no say in determining health policies.We also urge the Ministry of Health to expedite the drafting of the National Health Policy and the subsequent National Health Services Bill, as these will help address some of these challenges and contribute to the improvement of our nation’s health sector.Musonda Kamfwa, Ph.D(s) MPH MPA Secretary General Chairperson of the Committee on Health Services Clinical Officers Association of Zambia.",
  },
  {
    tag: "agm",
    image: "/images/img_37.jpg",
    date: "April 15, 2024",
    heading: "Advocacy in Health Care",
    content:
      "At the state level, the COAZ shapes the policy of influential national policymaking, partners with outside experts and stakeholder groups and influences the enactment and/or defeat of state legislation and regulation",
  },
  {
    tag: "agm",
    image: "/images/img_40.jpg",
    date: "April 15, 2024",
    heading: "Member Benefits",
    content:
      "Joining the nation’s largest Health professional Organization in Zambia has considerable benefits. In addition to opportunities to shape the future of health care, COAZ membership benefits include exclusive access to savings and resources designed to enhance the personal and professional lives of Members",
  },
];
export const events = [
  {
    image: "/images/img_e1.jpg",
    date: "October 14 to 16, 2025",
    title: "annual general meeting",
    start: "7:00 am",
    end: "10:00 am",
    venue: "City Lusaka",
  },
  {
    image: "/images/img_21.jpg",
    date: "April 18, 2024",
    title:
      "the vice president will be visiting our headquater offices in lusaka",
    start: "8:00 am",
    end: "10:00 am",
    venue: "Coaz headquaters",
  },
  {
    image: "/images/img_41.jpg",
    date: "April 20, 2024",
    title: "Appointment of the association's president",
    start: "8:00 am",
    end: "10:00 am",
    venue: "Coaz headquaters boardroom",
  },
  {
    image: "/images/img_39.jpg",
    date: "April 22, 2024",
    title: "welcoming of the new president",
    start: "10:00 am",
    end: "1:00 pm",
    venue: "Coaz headquaters main hall",
  },
];

export const sex = ["MALE", "FEMALE"];

export const idTypes = ["NRC", "PASSPORT", "DRIVERS_LICENSE"];